import ExploreTab from "Components/ExploreTab";
import LoadingIcon from "Components/LoadingIcon";
import navRoutes from "Navigation/NavRoutes";
import React, { Component } from "react";
import { IoMdCloudOutline } from "react-icons/io";
import { connect } from "react-redux";
import ProjectActions, { ProjectSelectors } from "Redux/ProjectRedux";
import styled from "styled-components";
import { Fonts } from "Themes";
import { mobileSize } from "Themes/Metrics";
import { CustomContainer } from "Themes/StyledComponents";

const MainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  padding-left: 0px;
  @media ${mobileSize.large} {
    padding: 0px;
  }
`;

const NoExploreContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const ErrorContainer = styled.div`
  color: red;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NoExploreData = (props) => {
  return (
    <NoExploreContainer>
      <IoMdCloudOutline size={150} />
      <h4>{props.text}</h4>
    </NoExploreContainer>
  );
};

// const Container = styled(MainContainerTheme)`
//   @media ${mobileSize.large} {
//     width: 100%;
//   }
// `;

class ExploreContainer extends Component {
  state = {
    fetching: true,
    error: false,
  };

  async componentDidMount() {
    const resolve = {
      onSuccess: () => this.setState({ fetching: false }),
      onFailure: () => this.setState({ fetching: false, error: true }),
    };
    await this.props.exploreProjects(resolve);
  }

  renderExploreData = () => {
    const { exploreData, history } = this.props;
    if (exploreData.length === 0) {
      return <NoExploreData text={"Looks like we can't find any projects"} />;
    }

    return exploreData.map((element, key) => {
      return (
        <ExploreTab
          key={key}
          data={element.project}
          title={element.projectName}
          text={element.projectDescription}
          avatar={element.projectManager.avatar}
          image={element.projectAvatar}
          onClick={() => history.push(`${navRoutes.explore}/${element.id}`)}
        />
      );
    });
  };

  render() {
    const { fetching, error } = this.state;
    return (
      <CustomContainer style={{ marginTop: "5%" }}>
        <h1 style={Fonts.headerFont}>Exploring Projects</h1>
        <MainContainer>
          {error ? (
            <ErrorContainer>Oops...there was an error</ErrorContainer>
          ) : fetching && !error ? (
            <LoadingIcon />
          ) : (
            this.renderExploreData()
          )}
        </MainContainer>
      </CustomContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    exploreData: ProjectSelectors.getExploreProjects(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    exploreProjects: (data) =>
      dispatch(ProjectActions.exploreProjectsRequest(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExploreContainer);
